module.exports = __webpack_public_path__ + "static/media/zh-CN.45c9c8bf.md";